(function($, w) {

    function Subscribe() {
        this.hostName = 'https://subscribe.mcn.com.au';
    }

    Subscribe.prototype.isStandardField = function(fieldName) {
        var standardFields = [
            'EMAIL',
            'FIRST_NAME',
            'LAST_NAME',
            'MOBILE',
            'TITLE'
        ];
        for(var i = 0; i < standardFields.length; i++) {
            if(standardFields[i] === fieldName) {
                return true;
            }
        }
        return false;
    };


    Subscribe.prototype.subscribe = function (data, groupNames, callback) {
        var endpoint = '/scripts/subscribe/subscribe.php?callback=?';
        var standardFields = {};
        var customFields = {};

        if(!(groupNames instanceof Array)) {
            groupNames = [groupNames];
        }

        for(var item in data) {
            if(data.hasOwnProperty(item)) {
                if(this.isStandardField(item)) {
                    standardFields[item] = data[item];
                }
                else {
                    customFields['cu_'+item] = data[item];
                }
            }
        }
        $.getJSON(this.hostName + endpoint, {
            st: standardFields,
            cu: customFields,
            gr: groupNames,
            format: 'json'
        }, callback);
    };


    w.MCN.SwiftDigital = w.MCN.SwiftDigital || {};
    w.MCN.SwiftDigital.Subscribe = new Subscribe();

})(jQuery, window);